import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import "../../assets/css/familyMembershipDetail.css";
import SideBar from "../../Components/SideBar/SideBar";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import TopBar from "../../Components/SideBar/TopBar";
import { arrow, ProBox } from "../../constant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import Signup from "./../Auth/Signup";
import {
  cancelMemberShipApiCall,
  GetCustomerMemberShip,
  updateFamilyMemberDetailsApi,
} from "../../network/Network";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

function FamilyMembershipDetail() {
  const Token = useSelector((state) => state.AuthReducer.token);
  const location = useLocation();
  const param = useParams();
  const navigate = useNavigate();
  const ImageUrlRedux = useSelector((state) => state.AuthReducer.urlData);
  const [newFile, setNewFile] = useState("");
  const [fileupload, setFileupload] = useState("");
  const [uploadLoading, setUploadLoading] = useState(false);
  const [state, setState] = useState(null);
  const [memberDetailsModal, setMemberDetailsModal] = useState({
    address: "",
    age: "",
    contact: "",
    dob: "",
    email: "",
    full_name: "",
    gender: "",
    id: null,
  });
  const [passwordChange, setPasswordChange] = useState(false);
  const [loading, setLoading] = useState(false);
  const [val, setVal] = useState({
    name: "John",
    email: "johnjack@check.com",
    contact: "9898989898",
    dob: "26/9/2121",
    age: "23",
    gender: "Male",
    address: "ajadshuahew",
  });

  const handleImageUpload = (e) => {
    e.preventDefault();
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.onloadend = () => {
      setNewFile(file);
      setFileupload(reader.result);
    };
    reader.readAsDataURL(file);
    setUploadLoading(true);
  };

  const MemberDetailsChangeFunc = (e) => {
    let { name, value } = e.target;
    setMemberDetailsModal({ ...memberDetailsModal, [name]: value });
  };

  const getMemberShipCurrentData = () => {
    setLoading(true);
    GetCustomerMemberShip(Token, param.id)
      .then((res) => {
        setState(res?.data?.response?.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const cancelMemberShip = (e) => {
    let sendData = {
      membership_id: state?.membership_id,
    };
    cancelMemberShipApiCall(Token, sendData)
      .then((res) => {
        toast.success(`Your family membership cancelled at the day end`);
        navigate("/");
      })
      .catch((err) => {});
  };

  const EditMemeberFunc = (item) => {
    setMemberDetailsModal({
      id: item.id,
      address: item.address,
      age: item.age,
      contact: item.contact,
      dob: item.dob,
      email: item.email,
      full_name: item.full_name,
      gender: item.gender,
    });
  };

  const saveMemberDetailApiFunc = (e) => {
    e.preventDefault();
    let sendData = {
      id: `${memberDetailsModal.id}`,
      book_membership_id: param.id,
      address: memberDetailsModal.address,
      age: `${memberDetailsModal.age}`,
      contact: memberDetailsModal.contact,
      dob: memberDetailsModal.dob,
      email: memberDetailsModal.email,
      full_name: memberDetailsModal.full_name,
      gender: memberDetailsModal.gender,
    };
    updateFamilyMemberDetailsApi(Token, sendData)
      .then((res) => {
        toast.success("family member details updated successfully");
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    getMemberShipCurrentData();
  }, []);

  return (
    <>
      <Header />
      {/* <!-- Universal Banner Sec End Here --> */}
      <section className="profile">
        <div className="container">
          <div className="row profile-row">
            <SideBar
              uploadLoading={uploadLoading}
              fileupload={fileupload}
              handleImageUpload={handleImageUpload}
            />
            <div className="col-lg-9">
              <div className="tab-content" id="v-pills-tabContent">
                <div
                  className="tab-pane fade active show"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  <TopBar />
                  <div className="row"></div>
                  <div className="row info-profile">
                    <div className="col-md-12 rightSide-profile">
                      <div className="row mb-4">
                        <div className="col-lg-6">
                          <div className="Accounts">
                            <h5>My Membership</h5>
                          </div>
                          <p className="expiryBtn">
                            Create date: {state?.created_at.slice(0, 10)}
                          </p>{" "}
                          <p className="expiryBtn">
                            Status :{" "}
                            {state?.subscription_status.replaceAll("_", " ")}
                          </p>
                        </div>
                        <div className="col-lg-6">
                          <div className="familyMember-Title ">
                            <button
                              onClick={() => {
                                navigate("/garden-tour");
                              }}
                              className="btn cancel-memberBtn3"
                            >
                              schedule Garden Tour &nbsp;&nbsp;
                              <img src={arrow} alt="" className="image-fluid" />
                            </button>

                            <button
                              disabled={
                                state?.subscription_status ==
                                "cancel_at_period_end"
                              }
                              onClick={cancelMemberShip}
                              className="btn cancel-memberBtn cancel-memberBtn5"
                            >
                              Cancel Membership &nbsp;&nbsp;
                              <img src={arrow} alt="" className="image-fluid" />
                            </button>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="row csa_Membership">
                        <div className="formContainer family-member_ship">
                          <div className="family_mem_booking">
                            <p className="sub-title">Members Details</p>
                          </div>
                          {state?.family_members?.map((item, index) => {
                            return (
                              <div key={index + 5612} className="row">
                                <div className="family_mem_booking">
                                  <p className="sub-title">
                                    Detail of Members # {index + 1}
                                  </p>
                                  <button
                                    onClick={() => {
                                      EditMemeberFunc(item);
                                    }}
                                    data-toggle="modal"
                                    data-target="#exampleModalLong"
                                  >
                                    Edit
                                  </button>
                                </div>
                                <div className="col-lg-6">
                                  <p className="sub-title-sm">Full Name</p>
                                  <input
                                    type="text"
                                    placeholder="Full Name"
                                    disabled
                                    value={item?.full_name}
                                  />
                                </div>
                                <div className="col-lg-6">
                                  <p className="sub-title-sm">Email</p>
                                  <input
                                    type="email"
                                    placeholder="Email"
                                    disabled
                                    value={item?.email}
                                  />
                                </div>
                                <div className="col-lg-6">
                                  <p className="sub-title-sm">Contact Number</p>
                                  <input
                                    type="number"
                                    placeholder="Number"
                                    disabled
                                    value={item?.contact}
                                  />
                                </div>
                                <div className="col-lg-6">
                                  <p className="sub-title-sm">Date Of Birth</p>
                                  <input
                                    type="text"
                                    placeholder="DOB"
                                    disabled
                                    value={item?.dob}
                                  />
                                </div>
                                <div className="col-lg-6">
                                  <p className="sub-title-sm">Age</p>
                                  <input
                                    type="number"
                                    placeholder="Age"
                                    disabled
                                    value={item?.age}
                                  />
                                </div>
                                <div className="col-lg-6">
                                  <p className="sub-title-sm">Gender</p>
                                  <input
                                    type="text"
                                    disabled
                                    placeholder="Gender"
                                    value={item?.gender}
                                  />
                                </div>
                                <div className="col-lg-6">
                                  <p className="sub-title-sm">Address</p>
                                  <input
                                    type="text"
                                    placeholder="Enter a Address"
                                    disabled
                                    // value={val.address}
                                    value={item?.address}
                                  />
                                </div>
                              </div>
                            );
                          })}
                        </div>
                        <div
                          className="modal fade"
                          id="exampleModalLong"
                          tabindex="-1"
                          role="dialog"
                          aria-labelledby="exampleModalLongTitle"
                          aria-hidden="true"
                        >
                          <div className="modal-dialog" role="document">
                            <div
                              className="modal-content"
                              style={{ background: "#f1efde" }}
                            >
                              <div className="modal-header">
                                <h5
                                  id="exampleModalLongTitle"
                                  style={{
                                    color: "#286152",
                                  }}
                                >
                                  Member Details
                                </h5>
                                <button
                                  type="button"
                                  className="close"
                                  data-dismiss="modal"
                                  aria-label="Close"
                                >
                                  <span
                                    aria-hidden="true"
                                    style={{
                                      color: "#286152",
                                    }}
                                  >
                                    &times;
                                  </span>
                                </button>
                              </div>
                              <form onSubmit={saveMemberDetailApiFunc}>
                                <div className="modal-body">
                                  <div className="formContainer family-member_ship">
                                    <div className="row ">
                                      <div className="col-lg-6">
                                        <p className="sub-title-sm">
                                          Full Name
                                        </p>
                                        <input
                                          style={{
                                            outline: "none",
                                          }}
                                          type="text"
                                          placeholder="Full Name"
                                          onChange={MemberDetailsChangeFunc}
                                          name="full_name"
                                          value={memberDetailsModal.full_name}
                                        />
                                      </div>
                                      <div className="col-lg-6">
                                        <p className="sub-title-sm">Email</p>
                                        <input
                                          style={{
                                            outline: "none",
                                          }}
                                          type="email"
                                          placeholder="Email"
                                          onChange={MemberDetailsChangeFunc}
                                          name="email"
                                          value={memberDetailsModal.email}
                                        />
                                      </div>

                                      <div className="col-lg-6">
                                        <p className="sub-title-sm">
                                          Contact Number
                                        </p>
                                        <input
                                          style={{
                                            outline: "none",
                                          }}
                                          type="number"
                                          placeholder="Number"
                                          onChange={MemberDetailsChangeFunc}
                                          name="contact"
                                          value={memberDetailsModal.contact}
                                        />
                                      </div>
                                      <div className="col-lg-6">
                                        <p className="sub-title-sm">
                                          Date Of birth
                                        </p>
                                        <input
                                          style={{
                                            outline: "none",
                                          }}
                                          type="text"
                                          placeholder="Date Of Birth"
                                          onChange={MemberDetailsChangeFunc}
                                          name="contact"
                                          value={memberDetailsModal.dob}
                                        />
                                      </div>
                                      <div className="col-lg-6">
                                        <p className="sub-title-sm">Age</p>
                                        <input
                                          style={{
                                            outline: "none",
                                          }}
                                          type="number"
                                          placeholder="Age"
                                          onChange={MemberDetailsChangeFunc}
                                          name="age"
                                          value={memberDetailsModal.age}
                                        />
                                      </div>
                                      <div className="col-lg-6">
                                        <p className="sub-title-sm mb-4">
                                          Gender
                                        </p>
                                        <label>Male</label>
                                        <input
                                          style={{
                                            outline: "none",
                                            marginLeft: "0.5rem",
                                            marginRight: "1rem",
                                            width: "10px",
                                          }}
                                          type="radio"
                                          placeholder="Gender"
                                          required
                                          onChange={MemberDetailsChangeFunc}
                                          name="gender"
                                          checked={
                                            memberDetailsModal.gender === "male"
                                          }
                                          value={"male"}
                                        />
                                        <label>Female</label>
                                        <input
                                          style={{
                                            outline: "none",
                                            marginLeft: "0.5rem",
                                            marginRight: "1rem",
                                            width: "10px",
                                          }}
                                          type="radio"
                                          placeholder="Gender"
                                          required
                                          onChange={MemberDetailsChangeFunc}
                                          name="gender"
                                          checked={
                                            memberDetailsModal.gender ==
                                            "female"
                                          }
                                          value={"female"}
                                        />
                                      </div>
                                      <div className="col-lg-6">
                                        <p className="sub-title-sm">Address</p>
                                        <input
                                          style={{
                                            outline: "none",
                                          }}
                                          type="text"
                                          placeholder="Enter Address"
                                          required
                                          onChange={MemberDetailsChangeFunc}
                                          name="address"
                                          value={memberDetailsModal.address}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="modal-footer">
                                  <button
                                    type="submit"
                                    className="btn"
                                    style={{
                                      color: "#fff",
                                      backgroundColor: "#286152",
                                      border: "none",
                                      outline: "none",
                                    }}
                                  >
                                    Save Changes
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default FamilyMembershipDetail;
